import { GridColumns, GridColumnHeaderParams } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { Avatar, MenuItem, Pagination, PaginationItem, Select } from "@mui/material";

//
function DragonAvatar(props: any) {
    // Check if egg!
    let isEgg = props.dragon.name.startsWith("Eternal Dragon Egg");

    return (
        <>
            <Box sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                cursor: "pointer"
            }}>
                {!isEgg &&
                    <>
                        <img src={"/mint/Frame_" + props.dragon.label + ".png"} style={{ width: "46px", height: "47px" }} />

                        <img src={`https://dragon.eternaldragons.com/${props.dragon.id}_sm.png`}
                            style={{
                                position: "absolute",
                                width: "42px",
                                height: "41px",
                                top: "3px",
                            }} />
                    </>}

                {isEgg && <img src={`https://dragon.eternaldragons.com/egg.png`}
                    style={{
                        position: "relative",
                        width: "35px",
                        height: "41px",
                        left: "5px"
                    }} />}
            </Box>
        </>
    )
}

//
export const columns: GridColumns = [
    {
        field: 'totalRank',
        headerName: 'Rank',
        width: 80,
        editable: false,
        headerClassName: 'super-app-theme--header',
        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Rank'}
            </strong>
        )
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
        editable: false,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
            let isEgg = params.row.name.startsWith("Eternal Dragon Egg");
            //console.log(params);
            return (

                <a href={isEgg ? '#' : `/dragon/${params.id}`} rel="noreferrer noopener">
                    <Box className="ranking-avatar" >
                        <DragonAvatar dragon={params.row} />
                        <Box className="ranking-avatar-name" >
                            {params.value}
                        </Box>

                    </Box>
                </a>

            );
        },

        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Name'}
            </strong>
        ),

    },
    {
        field: 'price',
        headerName: 'Market',
        width: 130,
        sortable: true,
        disableExport: true,
        headerClassName: 'super-app-theme--header',
        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Market'}
            </strong>
        ),
        renderCell: (params) => {
            return (

                <a href={`https://magiceden.io/item-details/${params.id}?name=${params.row.name}`} target="_blank" rel="noreferrer noopener">
                    <Box className="ranking-avatar" >
                        <Avatar sx={{ alignSelf: "center", width: 25, height: 25 }} variant="square" src="https://imagedelivery.net/E-VnZk4fwouzlzwX_qz4fg/532afb9b-8805-424d-8f85-da5c3e0f8600/public" />
                        <Box className="ranking-avatar-name" >
                            {params.row.price ? `${params.row.price} SOL` : ""}
                        </Box>
                    </Box>
                </a>
            );

        }
    },
    {
        field: 'batch',
        headerName: 'Batch',
    },
    {
        field: 'class',
        headerName: 'Class',
        width: 125,
        editable: false,
        headerClassName: 'super-app-theme--header',
        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Class'}
            </strong>
        ),
        cellClassName: "cell-overlay"
    },
    {
        field: 'affinity',
        headerName: 'Affinity',
        width: 125,
        headerClassName: 'super-app-theme--header',
        editable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Affinity'}
            </strong>
        ),
    },

    {
        field: 'label',
        headerClassName: 'super-app-theme--header',
        headerName: 'Rarity',
        sortable: true,
        width: 160,
        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Rarity'}
            </strong>
        ),
        cellClassName: "cell-overlay"
    },

    {
        field: 'total',
        headerName: 'Total Rarity',
        sortable: true,
        type: 'number',
        headerClassName: 'super-app-theme--header',
        filterable: false,

        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Total Rarity'}
            </strong>
        ),
        renderCell: (params: any) => {
            return (
                <Box>
                    {params.row.total}
                    {params.row.totalRank && <> - #{params.row.totalRank}</>}
                </Box>
            )
        },

        width: 150
    },
    {
        field: 'visual',
        headerName: 'Visual Rarity',
        sortable: true,
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: 160,
        filterable: false,

        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Visual Rarity'}
            </strong>
        ),
        renderCell: (params: any) => {
            return (
                <Box>
                    {params.row.visual}
                    {params.row.visualRank && <> - #{params.row.visualRank}</>}
                </Box>
            )
        },
        cellClassName: "cell-overlay"
    },
    {
        field: 'power',
        headerName: 'Power',
        sortable: true,
        type: 'number',
        headerClassName: 'super-app-theme--header',
        width: 150,
        filterable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Power'}
            </strong>
        ),
        renderCell: (params: any) => {
            return (
                <Box>
                    {params.row.power}
                    {params.row.powerRank && <> - #{params.row.powerRank}</>}
                </Box>
            )
        },

    },
    {
        field: 'gene',
        headerName: 'Gene Rarity',
        sortable: true,
        type: 'number',
        filterable: false,
        headerClassName: 'super-app-theme--header',
        width: 150,
        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Gene Rarity'}
            </strong>
        ),
        renderCell: (params: any) => {
            return (
                <Box>
                    {params.row.gene}
                    {params.row.geneRank && <> - #{params.row.geneRank}</>}
                </Box>
            )
        },
        cellClassName: "cell-overlay"
    },

];